export const footerColumns = [
  {
    title: 'Platform',
    links: [
      ['Employee Management', '/platform/employee-management'],
      ['Attendance', '/platform/attendance'],
      ['Leave', '/platform/leave'],
      ['Payroll', '/platform/payroll'],
      ['Performance', '/platform/performance'],
      ['Projects', '/platform/projects'],
      ['Production', '/platform/production'],
      ['Inventory', '/platform/inventory'],
      ['Analytics', '/platform/analytics'],
      ['AI Assistant', '/platform/ai'],
    ],
  },
  {
    title: 'Solutions',
    links: [
      ['Project Planning', '/solutions/project-planning'],
      ['Production Management', '/solutions/production-management'],
      ['Breakdown Management', '/solutions/breakdown-management'],
      ['Workforce Operations', '/solutions/workforce-operations'],
      ['Payroll & Compliance', '/solutions/payroll-compliance'],
      ['Performance Management', '/solutions/performance-management'],
    ],
  },
  {
    title: 'Industries',
    links: [
      ['Manufacturing', '/industries/manufacturing'],
      ['Garments & Textiles', '/industries/garments'],
      ['IT & Technology', '/industries/technology'],
      ['Construction', '/industries/construction'],
      ['Healthcare', '/industries/healthcare'],
      ['Retail', '/industries/retail'],
      ['Professional Services', '/industries/services'],
      ['View All Industries', '/industries'],
    ],
  },
  {
    title: 'Resources',
    links: [
      ['Documentation', '/resources/docs'],
      ['Blog', '/resources/blog'],
      ['FAQs', '/resources/faqs'],
      ['Security', '/security'],
    ],
  },
  {
    title: 'Company',
    links: [
      ['About Us', '/about'],
      ['Careers', '/careers'],
      ['Contact', '/contact'],
      ['Request Demo', '/request-demo'],
      ['Pricing', '/pricing'],
    ],
  },
] as const;
